@if (activeSourceGrp$()) {
  <form [formGroup]="activeSourceGrp$()" class="sources__form">
    <mat-card class="sources__form__card">
      <mat-card-title>
        <div class="title">
          <div class="eiq-id-badge">
            <span>{{ activeSourceGrp$().value.id }}</span>
          </div>
        </div>
        <div class="actions">
          <eiq-actions-menu [testId]="'source-actions'">
            <eiq-action-menu-item slot="menuItems" [testId]="'source-delete'" (clicked)="remove.emit()">
              <fa-icon slot="icon" class="eiq-icon-warn" [icon]="faTrash"></fa-icon>
              <span slot="text">Delete</span>
            </eiq-action-menu-item>
          </eiq-actions-menu>
        </div>
      </mat-card-title>
      <mat-card-content>
        <div class="sources__form__common">
          <div class="editor-question-form__input">
            <span class="label fs__md">Title</span>
            <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
              <input matInput formControlName="title" autocomplete="off" />
            </mat-form-field>
          </div>

          <mat-divider class="sources__form__divider"></mat-divider>

          <div class="sources__form__variables">
            <h3 class="fs__md fw__500">URL Variables</h3>
            @for (variable of activeSourceGrp$().controls.variables.controls; track variable.value.id; let ctrlIndex = $index) {
              <div class="sources__form__variable">
                <div class="editor-question-form__input sources__form__variable-field">
                  <span class="label text__sm fw__500">Name</span>
                  <span class="text__sm fw__600">{{ variable.value.variableToken }}</span>
                </div>
                <div class="editor-question-form__input sources__form__variable-field">
                  <span class="label text__sm fw__500">Required</span>
                  <span class="text__sm fw__600">{{ requiredTypeLabels[variable.value.variableRequiredType] }}</span>
                </div>
                <div class="editor-question-form__input sources__form__variable-field">
                  <span class="label text__sm fw__500">Type</span>
                  <span class="text__sm fw__600">{{ valueTypeLabels[variable.value.type] }}</span>
                </div>
                <div class="sources__form__variable-actions">
                  <eiq-actions-menu [testId]="'source-variable-' + ctrlIndex + '-actions'">
                    <eiq-action-menu-item slot="menuItems" [testId]="'source-variable-' + ctrlIndex + '-edit'" (clicked)="onEditVariable(ctrlIndex)">
                      <fa-icon slot="icon" [icon]="faPen"></fa-icon>
                      <span slot="text">Edit</span>
                    </eiq-action-menu-item>
                    <eiq-action-menu-item slot="menuItems" [testId]="'source-variable-' + ctrlIndex + '-delete'" (clicked)="onRemoveVariable(ctrlIndex)">
                      <fa-icon slot="icon" class="eiq-icon-warn" [icon]="faTrash"></fa-icon>
                      <span slot="text">Delete</span>
                    </eiq-action-menu-item>
                  </eiq-actions-menu>
                </div>
                @if (variable.value.type === listType) {
                  <div class="editor-question-form__input sources__form__variable-values">
                    <span class="label text__sm fw__500">Values</span>
                    <mat-chip-set aria-label="Variable values">
                      @for (option of variable.value.options; track option.id) {
                        <mat-chip>{{ option.value }}</mat-chip>
                      }
                    </mat-chip-set>
                  </div>
                }
              </div>
            }
            <button mat-flat-button color="primary" (click)="addVariable()">
              <fa-icon [icon]="faPlus"></fa-icon>
              Add Variable
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </form>
} @else {
  <div class="sources__empty">
    <svg width="480" height="392" viewBox="0 0 480 392" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_61_8819" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="-88" width="480" height="480">
        <rect width="480" height="480" transform="translate(0 -88)" fill="url(#paint0_radial_61_8819)" />
      </mask>
      <g mask="url(#mask0_61_8819)">
        <circle cx="240" cy="152" r="47.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="79.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="111.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="143.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="175.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="207.5" stroke="#EAECF0" />
        <circle cx="240" cy="152" r="239.5" stroke="#EAECF0" />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_61_8819"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(240 240) rotate(90) scale(240 240)"
        >
          <stop />
          <stop offset="1" stop-opacity="0" />
        </radialGradient>
      </defs>
    </svg>

    <div class="sources__empty-title">
      <fa-icon [icon]="faEyeSlash"></fa-icon>
      <h2 class="fs__lg fw__500">No sources yet</h2>
      <span class="fs__md">No problem! Add a source by clicking the button below</span>
    </div>

    <button mat-flat-button color="primary" (click)="addSource.emit()">
      <fa-icon [icon]="faPlus"></fa-icon>
      Add Source
    </button>
  </div>
}
